import { render } from "./name.vue?vue&type=template&id=6e79659e&scoped=true"
import script from "./name.vue?vue&type=script&lang=js"
export * from "./name.vue?vue&type=script&lang=js"

import "./name.vue?vue&type=style&index=0&id=6e79659e&lang=scss&scoped=true"

import exportComponent from "D:\\Vue-apps\\HIDABROOT\\hdb_memorial\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e79659e"]])

export default __exports__